
jQuery(document).ready(function($) {

    /* featured brands slider - footer */
    $("#testi_slider").slick({
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $('#testimonials__prev'),
        nextArrow: $('#testimonials__next'),
        mobileFirst: true,
        responsive: [
            {
                breakpoint:576,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint:768,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint:992,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint:1200,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    });
  



});